<template>
  <el-popover
    trigger="click"
    width="1200"
    @show="onPopoverShow">
    <span slot="reference" style="cursor:pointer;">{{taskId}}</span>

    <div>
        <div style="padding-left:20px;column-count:2;">
            <div>spName: {{approvalDetail.spName}}</div>
            <div>applyTime: {{approvalDetail.applyTime}}</div>
            <div>templateId: {{approvalDetail.templateId}}</div>
            <div>applyerUserId: {{approvalDetail.applyerUserId}}</div>
            <div>spStatus: {{approvalDetail.spStatus}}</div>
        </div>

        <TicketTaskForm :taskId="formTaskId"/>
    </div>
  </el-popover>
</template>

<script>
export default {
    name: 'WorkWeixingetApprovalDialog',

    props: ['taskId'],

    data() {
        return {
            formTaskId: null,
            approvalDetail: {}
        }
    },

    methods: {
        onPopoverShow() {
            this.formTaskId = this.taskId;

            this.getApprovalDetail();
        },

        getApprovalDetail() {
            var _this = this;
            sdk.WxApi().getApprovalDetail({
                spNo: _this.taskId
            }).then(res => {
                _this.approvalDetail = res || {};
            });
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/WorkWeixingetApprovalDialog.vue